import axios from 'axios';

import { getV2RootUrl, publicAxiosHeaderV2 } from 'common/helpers/apiHelper';

export const getForWeb = () =>
  axios.get(
    `${getV2RootUrl()}/setting/for-web?version=V2`,
    publicAxiosHeaderV2()
  );
